export const marketEs = {
  market: {
    title: "Inteligencia de Mercado",
    subtitle: "Mantente actualizado con las tendencias del mercado agrícola",
    currentPrices: "Precios Actuales",
    priceHistory: "Historial de Precios",
    forecasts: "Pronósticos",
    commodities: "Materias Primas",
    wheat: "Trigo",
    corn: "Maíz",
    soybeans: "Soja",
    olives: "Aceitunas",
    grapes: "Uvas",
    pricePerTon: "Precio por tonelada",
    change: "Cambio",
    trend: "Tendencia",
    up: "Al alza",
    down: "A la baja",
    stable: "Estable"
  },
  marketPage: {
    title: "Precios de Mercado",
    subtitle: "Precios internacionales de materias primas y análisis de mercado para productos agrícolas",
    overview: "Resumen",
    forecasts: "Pronósticos",
    calculator: "Calculadora",
    priceTrends: "Tendencias de Precios",
    priceTrendsDesc: "Análisis histórico y pronósticos",
    regionalComparison: "Comparación Regional",
    regionalComparisonDesc: "Referencias de precios internacionales",
    marketAnalytics: "Análisis de Mercado",
    marketAnalyticsDesc: "Insights avanzados del mercado",
    marketHighlights: "Destacados del Mercado",
    globalMarketConditions: "🌍 Condiciones del Mercado Global",
    globalMarketDesc: "Los mercados agrícolas mediterráneos muestran estabilidad estacional con fuerte demanda de consumidores europeos. Condiciones climáticas favorables para las expectativas de cosecha actuales.",
    tradingOpportunities: "📈 Oportunidades Comerciales",
    tradingOpportunitiesDesc: "Los productos de calidad premium obtienen precios más altos. Considera el momento estratégico para la cosecha y venta basándote en las primas actuales del mercado.",
    marketIntelligence: "Inteligencia de Mercado",
    marketDataSources: "Fuentes de Datos del Mercado",
    marketDataSourcesDesc: "Precios de: International Olive Council (IOC) • Organisation Internationale de la Vigne et du Vin (OIV) • Mercasa España • Alpha Vantage • Trading Economics • Feeds en tiempo real"
  },
  forecast: {
    title: "Pronósticos de Precios de Materias Primas",
    subtitle: "Pronósticos con IA de Perplexity Finance con datos reales de bolsas",
    commodity: "Materia Prima",
    timeframe: "Horizonte",
    refreshForecast: "Actualizar Pronóstico",
    loading: "Cargando...",
    generatingForecast: "Generando pronóstico...",
    currentPrice: "Precio Actual",
    forecastRange: "Rango de Pronóstico",
    marketDirection: "Dirección del Mercado",
    confidenceLevel: "Nivel de Confianza",
    bullish: "Alcista",
    bearish: "Bajista",
    neutral: "Neutral",
    detailedAnalysis: "Análisis Detallado del Mercado",
    futuresContracts: "Contratos de Futuros",
    exchange: "Bolsa",
    contractMonth: "Mes de Contrato",
    priceUsd: "Precio (USD)",
    priceEur: "Precio (EUR)",
    change: "Variación",
    riskFactors: "Factores de Riesgo",
    supplyDemand: "Oferta y Demanda",
    supply: "Oferta",
    demand: "Demanda",
    recommendation: "Recomendación",
    dataSources: "Fuentes de Datos",
    sourceType: "Tipo",
    sourceName: "Fuente",
    noForecast: "Sin pronóstico disponible. Haz clic en 'Actualizar Pronóstico' para generar uno.",
    forecastUpdated: "Pronóstico Actualizado",
    expertViews: "Opiniones de Expertos",
    analystConsensus: "Consenso de Analistas",
    seasonalPattern: "Patrón Estacional",
    yearOverYear: "Interanual",
    high: "Alto",
    medium: "Medio",
    low: "Bajo",
    buy: "Comprar",
    sell: "Vender",
    hold: "Mantener",
    probability: "Probabilidad",
    impact: "Impacto",
    positive: "Positivo",
    negative: "Negativo",
    "7days": "7 Días",
    "30days": "30 Días",
    "90days": "90 Días",
    perUnit: "por",
    expectedChange: "Cambio esperado",
    basedOnAnalysis: "Basado en análisis de mercado",
    oliveOil: "Aceite de Oliva Virgen Extra",
    wineGrapes: "Uva de Vino (Tempranillo)",
    tableGrapes: "Uva de Mesa",
    wheatLabel: "Trigo",
    cornLabel: "Maíz",
    sunflowerLabel: "Girasol",
    canolaLabel: "Colza",
    soybean: "Soja",
    barley: "Cebada",
    rice: "Arroz",
    "1month": "1 Mes",
    "3months": "3 Meses",
    "6months": "6 Meses",
    "12months": "12 Meses"
  },
  priceTrend: {
    title: "Análisis Histórico de Precios",
    chartLine: "Línea",
    chartArea: "Área",
    generateHistory: "Generar Historial",
    generating: "Generando...",
    historicalMin: "Mínimo Histórico",
    historicalMax: "Máximo Histórico",
    averagePrice: "Precio Promedio",
    currentPrice: "Precio Actual",
    volatility: "Volatilidad",
    dataPoints: "Puntos de Datos",
    priceChange: "Cambio de Precio",
    dayForecast: "Pronóstico 7 Días",
    priceVolatility: "Volatilidad del Precio",
    marketRecommendation: "Recomendación de Mercado",
    officialSources: "Fuentes Oficiales de Datos",
    noData: "No hay datos de precios disponibles",
    "7days": "7 Días",
    "30days": "30 Días",
    "3months": "3 Meses",
    "6months": "6 Meses",
    "1year": "1 Año",
    "2years": "2 Años"
  },
  regional: {
    title: "Comparación Regional de Precios",
    region: "Región",
    price: "Precio",
    quality: "Calidad",
    marketSource: "Fuente de Mercado",
    competitiveness: "Competitividad",
    lastUpdated: "Última Actualización",
    competitive: "Competitivo",
    premium: "Premium",
    marketRate: "Precio de Mercado",
    insights: "Perspectivas del Mercado Regional",
    competitiveDesc: "Precio 5%+ por debajo del promedio - Buena oportunidad de compra",
    premiumDesc: "Precio 5%+ por encima del promedio - Calidad premium o oferta limitada",
    marketRateDesc: "Precio dentro de ±5% del promedio - Condiciones estándar",
    noData: "No hay datos de precios regionales disponibles"
  },
  analytics: {
    title: "Análisis de Mercado",
    subtitle: "Análisis avanzado de tendencias, volatilidad y predicciones de mercado",
    aiIntelligence: "IA Inteligente",
    updateData: "Actualizar Datos",
    currentPrice: "Precio Actual",
    change: "Variación",
    volatility: "Volatilidad",
    forecast30d: "Pronóstico 30d",
    priceEvolution: "Evolución del Precio",
    marketAnalysis: "Análisis de Mercado",
    currentTrend: "Tendencia Actual",
    periodData: "Datos del Período",
    periodDataDesc: "Análisis basado en {count} puntos de datos reales de fuentes oficiales agrícolas y de mercados de materias primas.",
    forecasts: "Pronósticos",
    marketRecommendation: "Recomendación de Mercado",
    keyFactors: "Factores Clave",
    realTimeDataSources: "Fuentes de Datos en Tiempo Real",
    dataSourcesDesc: "Datos de mercados oficiales: MATIF • IOC • OIV • MAPA España • Poolred • Análisis IA via Perplexity sonar-pro",
    aiMarketIntelligence: "Inteligencia de Mercado IA",
    marketAssessment: "Evaluación del Mercado",
    keyMarketDrivers: "Factores Clave del Mercado",
    aiRecommendation: "Recomendación IA",
    sources: "Fuentes",
    couldNotLoad: "No se pudieron cargar los datos de análisis del mercado."
  }
};
